import React from 'react';
import styled from 'styled-components';
import { useChangeAwareEffect } from 'use-change-aware-effect';
import { SectionContainer, SectionTitle } from '../../shared/sectionable/styles';
import propTypes from '../common/prop-types';
import Details from './performance-components/details';
import { scrollIfHashMatch } from '../../shared/navigation/utils';
import useFundStateStore from '../common/fund-state-hook';

const Container = styled(SectionContainer)`
  margin-top: 48px;
  margin-bottom: 0;

  ${props => (props.theme.isMobile ? `
    margin-bottom: 24px;
  ` : `
    &:not(:first-child) {
      border-top: 1px solid #d7dfe7;
      padding-top: 72px;
    }
  `)};
`;

const sectionName = 'fund-performance';

export default function Performance({ fund }) {
  const set = useFundStateStore(state => state.set);

  useChangeAwareEffect(({ isMount }) => {
    isMount && scrollIfHashMatch(sectionName);
    set(state => {
      state.hasPerformanceUpdates = true;
    });
  }, {});

  return (
    <Container name={sectionName}>
      <SectionTitle>performance</SectionTitle>
      <Details fund={fund} />
    </Container>
  );
}

/* eslint-disable-next-line react/require-default-props */
Performance.propTypes = { fund: propTypes.fund };
